import fetch from 'isomorphic-fetch';
import { checkStatus } from '../../util';
import { ROOT } from '../../../constants/root';

export function getShapes() {
	return function(dispatch, getState) {		

		const URL = `${ROOT}/shape/`;		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then(checkStatus)
		.then((response) => response.json())
		.then((json) => {
			dispatch(setShapes(json));
		})
		.catch((e) => {
			console.error(e);			
		});
	};
}

function setShapes(shapes) {
	return {
		type: "SET_SHAPES",
		shapes
	};	
}


// WEBPACK FOOTER //
// ./src/state/domains/shapes/actions.js